import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=52607ace&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52607ace')) {
      api.createRecord('52607ace', component.options)
    } else {
      api.reload('52607ace', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=52607ace&", function () {
      api.rerender('52607ace', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8C5fXYXnf7g1o/JS/pricehelp.vue"
export default component.exports